import React from 'react';
import IconBase, { TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const LinkIcon = React.memo(function LinkIcon(props: TLinkIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Link" {...props}>
            <path d="M12.3327 14.2964C12.3004 14.2644 12.2568 14.2465 12.2113 14.2465C12.1659 14.2465 12.1223 14.2644 12.09 14.2964L9.59347 16.7929C8.43761 17.9488 6.48683 18.0712 5.21065 16.7929C3.93233 15.5146 4.05479 13.5659 5.21065 12.4101L7.70714 9.9136C7.77374 9.847 7.77374 9.73743 7.70714 9.67083L6.85206 8.81575C6.81976 8.78376 6.77613 8.76582 6.73067 8.76582C6.68521 8.76582 6.64159 8.78376 6.60929 8.81575L4.1128 11.3122C2.29522 13.1298 2.29522 16.071 4.1128 17.8865C5.93038 19.7019 8.87159 19.704 10.687 17.8865L13.1835 15.39C13.2501 15.3234 13.2501 15.2138 13.1835 15.1472L12.3327 14.2964ZM17.8886 4.11282C16.071 2.29524 13.1298 2.29524 11.3144 4.11282L8.81573 6.6093C8.78375 6.64161 8.7658 6.68523 8.7658 6.73069C8.7658 6.77615 8.78375 6.81977 8.81573 6.85208L9.66866 7.70501C9.73526 7.77161 9.84483 7.77161 9.91143 7.70501L12.4079 5.20852C13.5638 4.05266 15.5146 3.9302 16.7907 5.20852C18.0691 6.48684 17.9466 8.43547 16.7907 9.59133L14.2942 12.0878C14.2623 12.1201 14.2443 12.1637 14.2443 12.2092C14.2443 12.2547 14.2623 12.2983 14.2942 12.3306L15.1493 13.1857C15.2159 13.2523 15.3255 13.2523 15.3921 13.1857L17.8886 10.6892C19.704 8.87161 19.704 5.9304 17.8886 4.11282V4.11282ZM13.1083 7.99934C13.076 7.96735 13.0324 7.94941 12.9869 7.94941C12.9415 7.94941 12.8978 7.96735 12.8655 7.99934L7.99933 12.8634C7.96734 12.8957 7.9494 12.9393 7.9494 12.9848C7.9494 13.0303 7.96734 13.0739 7.99933 13.1062L8.85011 13.957C8.91671 14.0236 9.02628 14.0236 9.09288 13.957L13.9569 9.0929C14.0235 9.02629 14.0235 8.91672 13.9569 8.85012L13.1083 7.99934Z" />
        </IconBase>
    );
});

export default LinkIcon;

// #region Types

export type TLinkIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <LinkIcon /> : { ...IconBaseExample, render: LinkIcon };

// #endregion
